<template>
  <svg :fill="fillColor"
       class="material-design-icon__svg"
       viewBox="0 0 24 24">
    <path d="M3,4H5V10H9V4H11V18H9V12H5V18H3V4M14,18V16H16V6.31L13.5,7.75V5.44L16,4H18V16H20V18H14Z"/>
  </svg>
</template>

<script>
export default {
  name: "FormatHeader1Icon",
  props: {

    fillColor: {
      type: String,
      default: "currentColor"
    },
  }
}
</script>
